import React, { useState, useEffect, useRef } from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import {
  FooterLoginPure,
  DialogTermsCond,
  DialogPoliticyPrivacy,
  IconLanguageHLPure,
  DialogSystemGLPure
} from "../../pures";
import { useTranslation } from "react-i18next";
// import logoAkubicaFirmaDigital from "../../../assets/logos/logo_akubicaFirmaDigital_New.png";
// import govoLogo from "../../../assets/logos/logo_govo.legal.jpg";
// import a3logo from "../../../assets/logos/a3logo.png";
import { IconUlLogin, LogoGovoLegalLogin } from "../../../assets/logos/icons";
import "./login.view.css";
import { LocalStorageService } from "../../../services";
import SvgIcon from "@material-ui/core/SvgIcon";
import { LogoColor, LogoWhite } from "../../../assets/assets";

const LoginView = (props) => {
  const matches = useMediaQuery("(min-width:740px)");
  const { t, ready, i18n } = useTranslation();
  const [modalTermsCond, setModalTermsCond] = useState(null);
  const [modalPolicityPrivacy, setModalPolicityPrivacy] = useState(null);
  const inputRef = useRef(null)

  let localStorageService = new LocalStorageService();

  const openModalTermsCond = (value) => {
    setModalTermsCond(value);
  };

  const openModalPolicityPrivacy = (value) => {
    setModalPolicityPrivacy(value);
  };

  const [clientLogo, setclientLogo] = useState(null);
  useEffect(() => {
    let localStorageService = new LocalStorageService();
    let logo = localStorageService.getLocalStorageItem("clientLogo");
    if (logo) {
      setclientLogo(logo);
    }
  }, []);
  let loginContainerGridInformation = {};
  let generalContainerGrid = {};

  if (matches) {
    generalContainerGrid = {
      minHeight: "435px",
      minWidth: "675px",
      maxWidth: "min-content",
      justifyContent: "center",
      margin: "auto",
    };
    loginContainerGridInformation = {
      backgroundColor: clientLogo ? "#687687" : "#427fba",
      position: "relative",
      borderRight: clientLogo ? "1px solid #9C9C9C" : "1px solid #427fba",
    };
  } else {
    loginContainerGridInformation = {
      backgroundColor: clientLogo ? "#687687" : "#427fba",
      position: "relative",
      borderRight: clientLogo ? "1px solid #9C9C9C" : "1px solid #427fba",
      display: "none",
    };
    generalContainerGrid = {
      minHeight: "435px",
      maxWidth: "min-content",
      justifyContent: "center",
      margin: "auto",
    };
  }
  const generalContainelorItemGrid = {
    backgroundColor: "#FFFFFF",
    textAlign: "center",
    minWidth: "300px",
  };
  const loginItemContainerSendEmailMargin = {
    marginBottom: "10px",
  };
  const loginItemContainerDivSendEmail = {
    fontSize: "14px",
    color: "#4D4D4D",
    padding: "0px 20px",
  };
  const loginItemContainerButtonLogIn = {
    position: "relative",
    top: "100%",
    width: "100%",
  };
  const loginContainerGridInformationFooter = {
    position: "absolute",
    bottom: "5%",
    width: "100%",
  };

  const changePreference = (language) => {
    if (!language) return
    language = language || "es"
    props.setFlags(language)
    localStorageService.setLocalStorageItem("preferredLanguage", language)
    i18n.changeLanguage(language);
  }

  if (!ready) {
    return <p></p>;
  } else {
    return (
      <div className="main-login">
        <div className="login-image-backgroud">
          <div className="login-wrapper">
            <Grid
              container
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              style={generalContainerGrid}
            >
              {/* CARD VERDE PARA INFORMACION ADICIONAL */}
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                es={6}
                xs={6}
                style={loginContainerGridInformation}
              >
                <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
                  {props.templateRendering === "login" ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="login-welcome-container">
                        <div
                          style={{
                            height:
                              props.templateRendering !== "login"
                                ? "70px"
                                : "70px",
                            width: "100px",
                          }}
                        />
                        <div className={`login-welcome-labels-container`}>
                          <p className="login-welcome-labels-container-title">
                            {t("loginView.labelLoginSubtitleWelcome")}
                          </p>
                          <p className="login-welcome-labels-container-login-p">
                            {t("loginView.labelLoginTextAKubicaFirmaDigital")}
                          </p>
                          {/* <p className="login-welcome-labels-container-login-p">{t('loginView.labelLoginTextTheIdealPlatform')}</p>
                                                    <p className="login-welcome-labels-container-login-p"><span className={clientLogo ? 'login-welcome-labels-container-span-logo' : 'login-welcome-labels-container-span'}>{t('loginView.labelLoginTextToSigndocuments')}</span></p>
                                                    <p className="login-welcome-labels-container-login-p"><span className={clientLogo ? 'login-welcome-labels-container-span-logo' : 'login-welcome-labels-container-span'}>{t('loginView.labelLoginTextInAgile')}</span>{t('loginView.labelLoginTextInSafeWay')}</p>
                                                    <p className="login-welcome-labels-container-login-p">{t('loginView.labelLoginTextWithThe')} {t('loginView.labelLoginTextHighLevel')} {t('loginView.labelLoginTextOf')} </p>
                                                    <p className="login-welcome-labels-container-login-p">{t('loginView.labelLoginTextLegalSupportThere')}</p>
                                                    <p className="login-welcome-labels-container-login-p">{t('loginView.labelLoginTextMexicanMarket')}</p> */}
                        </div>
                      </div>
                    </Grid>
                  ) : props.templateRendering === "register" ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="login-welcome-container">
                        <div
                          style={{
                            height:
                              props.templateRendering !== "login"
                                ? "50px"
                                : "50px",
                            width: "100px",
                          }}
                        />
                        <div className={`login-welcome-labels-container`}>
                          <p className="login-welcome-labels-container-register-title">
                            {t("loginView.labelRegisterSubtitleWelcome")}
                          </p>
                          <p className="login-welcome-labels-container-register-title">
                            {t("loginView.labelRegisterTextSignUpProcess")}
                          </p>
                          <div className="login-welcome-labels-container-register-separator">
                            <div className="login-welcome-labels-container-register-div">
                              <span>
                                <img src={IconUlLogin} width={20} />
                              </span>
                              <p className="login-welcome-labels-container-register-ul">
                                {t(
                                  "loginView.labelRegisterTextSProvideAnEmail"
                                )}
                              </p>
                            </div>
                            <div className="login-welcome-labels-container-register-div">
                              <span>
                                <img src={IconUlLogin} width={20} />
                              </span>
                              <p className="login-welcome-labels-container-register-ul">
                                {t(
                                  "loginView.labelRegisterTextProvidePasswordAndItsConfirmation"
                                )}
                              </p>
                            </div>
                            <div className="login-welcome-labels-container-register-div">
                              <span>
                                <img src={IconUlLogin} width={20} />
                              </span>
                              <p className="login-welcome-labels-container-register-ul">
                                {t(
                                  "loginView.labelRegisterTextYouWillReceiveAndconfirmationEmail"
                                )}
                              </p>
                            </div>
                            <div className="login-welcome-labels-container-register-div">
                              <span>
                                <img src={IconUlLogin} width={20} />
                              </span>
                              <p className="login-welcome-labels-container-register-ul">
                                {t(
                                  "loginView.labelRegisterTextOnceAcceptYouCanAccess"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ) : props.templateRendering === "forgotPassword" ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="login-welcome-container">
                        <div
                          style={{
                            height:
                              props.templateRendering !== "login"
                                ? "50px"
                                : "50px",
                            width: "100px",
                          }}
                        />
                        <div className={`login-welcome-labels-container `}>
                          <p className="login-welcome-labels-container-register-title">
                            {t(
                              "loginView.labelForgotPasswordSubtitleHaveYourForgotten"
                            )}
                          </p>
                          <p className="login-welcome-labels-container-register-title">
                            {t(
                              "loginView.labelForgotPasswordSubtitleThePassword"
                            )}
                          </p>
                          <div className="login-welcome-labels-container-register-separator"></div>
                          <p className="login-welcome-labels-container-login-p">
                            {t(
                              "loginView.labelForgotPasswordTextSendARecoveryEmail"
                            )}
                          </p>
                          <p className="login-welcome-labels-container-login-p">
                            {t(
                              "loginView.labelForgotPasswordTextTheInstructiosWillBeSend"
                            )}
                          </p>
                          {/* <p className="login-welcome-labels-container-login-p">{t('loginView.labelForgotPasswordTextToChangeThePassword')}</p> */}
                          {/* <p className="login-welcome-labels-container-login-p">{t('loginView.labelForgotPasswordTextRecoveryTheAccount')}</p> */}
                        </div>
                      </div>
                    </Grid>
                  ) : null}

                  {/* Footer informacion del login */}
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={loginContainerGridInformationFooter}
                  >
                    {/* {clientLogo && (
                                            <div className="login-footer-container">
                                                <img src={a3logo} alt={'Logo aKúbica '} style={{ padding: '10px', maxWidth: '30%' }} />
                                                <img src={logoAkubicaFirmaDigital} alt={'Logo hibou.legal'} style={{ padding: '10px', maxWidth: '30%' }} />
                                            </div>
                                        )} */}
                    <div
                      className={`login-footer-container`}
                    >
                      <img
                        src={LogoWhite}
                        width={100}
                        alt={"Logo Govo.Legal login"}
                      />
                      <div className={`login-footer-labels-container`}>
                        <p>
                          {t(
                            "loginView.textAkubicaFirmaDigitalAServiceCreatedFor"
                          )}
                        </p>
                        <p>{t("loginView.textA3Microservice")}</p>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              {/* CARD PARA FORMULARIO DE LOGIN / REGISTRO USUARIO */}
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                es={6}
                xs={6}
                style={generalContainelorItemGrid}
              >
                <Grid
                  container
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  style={{ position: "relative" }}
                >
                  {/* Logo y Menu botones */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {clientLogo ? (
                      <img
                        src={clientLogo}
                        alt={"Logo govo.legal"}
                        style={{
                          padding: "10px",
                          height: "110px",
                          width: "100%",
                          objectFit: "contain",
                          boxSizing: "border-box"
                        }}
                      />
                    ) : (
                      <img
                        src={LogoColor}
                        width={247}
                        height={58}
                        alt={"Logo govo.legal"}
                        style={{ padding: "10px", paddingTop: "20px" }}
                      />
                    )}

                    {/* Titulo cambiante de Login, Registrarse y Cambio de contraseña */}
                    <div className="login-container-buttons-signin-singup">
                      {props.templateRendering === "login" ? (
                        <div className="loginView-container-languaje">
                          <span className={`login-title-signin-signup`}>
                            {t("loginView.labelTitleLogIn")}
                          </span>
                          {(props.flags && props.flags.length > 0) ? (
                            <div className="loginView-flags-container">
                              <div className="loginView-world">
                                <img
                                  src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_WORLD}`}
                                  width={22}
                                  height={22}
                                  alt={'worldLanguage'}
                                />
                              </div>
                              {
                                props.flags.map((flag) => (
                                  <div className="loginView-flags" onClick={() => changePreference(flag.language)}>
                                    <IconLanguageHLPure
                                      label={flag.label}
                                      status={flag.status}
                                    />
                                  </div>
                                ))
                              }
                            </div>
                          ) : null
                          }
                        </div>
                      ) : props.templateRendering === "register" ? (
                        <span className={`login-title-signin-signup`}>
                          {t("loginView.labelTitleRegister")}
                        </span>
                      ) : props.templateRendering === "forgotPassword" ? (
                        <span className={`login-title-signin-signup`}>
                          {t("loginView.labelTitleForggotPassword")}
                        </span>
                      ) : null}
                    </div>

                    {/* Mensajes de error */}
                    {props.errorForm === true ? (
                      <Grid lg={12} md={12} sm={12} item xs={12}>
                        <div className="login-container-error-label">
                          <p className="login-error-label">
                            <span>{props.errorMessage}</span>
                            <div
                              className="login-error-label-icon-close"
                              onClick={props.onHandleHideError}
                            >
                              <i className="fas fa-times" />
                            </div>
                          </p>
                        </div>
                      </Grid>
                    ) : null}

                    {/* Mensajes de exito */}
                    {props.successForm === true ? (
                      <Grid lg={12} md={12} sm={12} item xs={12}>
                        <div className="login-container-success-label">
                          <p className="login-success-label">
                            <span>{props.successMessage}</span>
                          </p>
                        </div>
                      </Grid>
                    ) : null}

                    {/* Boton regresar cambio de contraseña */}
                    {props.templateRendering === "forgotPassword" ? (
                      <div
                        className="login-button-back"
                        onClick={() => props.onHandleSelectTemplate("login")}
                      >
                        <div>
                          <i className="fas fa-chevron-left login-button-back-icon"></i>
                          <span>{t("button.return")}</span>
                        </div>
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {/* FORM LOGIN */}
                    {props.templateRendering === "login" ? (
                      <Grid lg={12} md={12} sm={12} container xs={12}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                        >
                          {/* Input login correo */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="far fa-envelope login-input-icon" />
                            </div>
                            <input
                              placeholder={t("loginView.placeholderEmail")}
                              type="text"
                              className="login-input"
                              id="email"
                              value={props.email}
                              autoFocus={props.email ? false : true}
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) => props.onHandleLoginKeypress(e)}
                            />
                          </div>
                          {/* Input login contraseña */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="fas fa-lock login-input-icon" />
                            </div>
                            <input
                              placeholder={t("loginView.placeholderPassword")}
                              type="password"
                              className="login-input"
                              id="password"
                              value={props.password}
                              autoFocus={props.email ? true : false}
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) => props.onHandleLoginKeypress(e)}
                            />
                            <div onClick={props.onHandleShowPassword}>
                              {/* <i className="fas fa-eye" /><i class="fa-solid fa-eye"></i> */}
                              <SvgIcon
                                className={`login-input-show-password-container-icon ${props.loginShowPasswordIcon}`}
                              >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                              </SvgIcon>
                            </div>
                          </div>
                          {/* Boton Iniciar sesión */}
                          <div
                            className="login-input-button-login-register-forgotPassword"
                            onClick={(e) => props.onHandleLogin(e)}
                          >
                            {props.loading === true ? (
                              <p className="preloader"></p>
                            ) : (
                              <div>
                                <span>{t("loginView.buttonLogIn")}</span>
                                <i className="fas fa-chevron-right login-input-login-title-icon"></i>
                              </div>
                            )}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          {props.hideTemplatesInvitedColaborator !==
                            false ? null : (
                            <div className="login-div-fogotten-password">
                              <p>
                                <span
                                  className="login-p-fogotten-password"
                                  onClick={() =>
                                    props.onHandleSelectTemplate(
                                      "forgotPassword"
                                    )
                                  }
                                >
                                  {t("loginView.labelLinkForggotPassword")}
                                </span>
                              </p>
                              <p>
                                {t(
                                  "loginView.labelForggotPasswordYouDontHaveAccountYet"
                                )}{" "}
                                <span
                                  className="login-p-fogotten-password-link"
                                  onClick={() =>
                                    props.onHandleSelectTemplate("register")
                                  }
                                >
                                  {t("loginView.labelForggotPassworClicHere")}
                                </span>
                              </p>
                            </div>
                          )}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className="login-div-legal-documents">
                            <p>
                              {t("loginView.textByEnteringYouAcceptOurs")}
                              <span
                                className="login-div-legal-documents-link"
                                onClick={() => {
                                  openModalTermsCond(true);
                                }}
                              >
                                {t("loginView.textTermsAndConditions")}
                              </span>
                              <span>{t("loginView.textAsWellThe")}</span>
                              <span
                                className="login-div-legal-documents-link"
                                onClick={() => {
                                  openModalPolicityPrivacy(true);
                                }}
                              >
                                {t("loginView.textPolicityPrivacy")}
                              </span>
                              {t("loginView.wspHelp")}{" "}
                              <a
                                style={{
                                  textDecoration: "underline",
                                  color: "#427fba",
                                }}
                                href="https://wa.link/wjw511"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("loginView.wspLink")}
                              </a>
                            </p>
                          </div>
                        </Grid>
                      </Grid>
                    ) : null}

                    {/* FORM REGISTER */}
                    {props.templateRendering === "register" ? (
                      <Grid container lg={12} md={12} sm={12} xs={12}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                        >
                          {/* Input registro correo */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="far fa-envelope login-input-icon" />
                            </div>
                            <input
                              placeholder={t("loginView.placeholderEmail")}
                              type="text"
                              className="login-input"
                              id="newEmail"
                              value={props.newEmail}
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) =>
                                props.onHandleSignUpKeypress(e)
                              }
                            />
                          </div>
                          {/* Input registro contraseña */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="fas fa-lock login-input-icon" />
                            </div>
                            <input
                              placeholder={t("loginView.placeholderPassword")}
                              type="password"
                              className="login-input"
                              id="newPassword"
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) =>
                                props.onHandleSignUpKeypress(e)
                              }
                            />
                            <div
                              onClick={props.onHandleShowPasswordRegister}
                            >
                              <SvgIcon
                                className={`login-input-show-password-container-icon ${props.loginShowPasswordRegisterIcon}`}
                              >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                              </SvgIcon>
                            </div>
                          </div>
                          {/* Input registro repetir contraseña */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="fas fa-lock login-input-icon" />
                            </div>
                            <input
                              placeholder={t(
                                "loginView.placeholderConfirmPassword"
                              )}
                              type="password"
                              className="login-input"
                              id="repeatNewPassword"
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) =>
                                props.onHandleSignUpKeypress(e)
                              }
                            />
                            <div
                              onClick={props.onHandleShowPasswordRepeatRegister}
                            >
                              <SvgIcon
                                className={`login-input-show-password-container-icon ${props.loginShowPasswordRepeatRegisterIcon}`}
                              >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                              </SvgIcon>
                            </div>
                          </div>

                          {/* Boton Registrarse */}
                          <div
                            className="login-input-button-login-register-forgotPassword"
                            onClick={(e) => props.onHandleSignUp(e)}
                          >
                            {props.loading === true ? (
                              <p className="preloader"></p>
                            ) : (
                              <div>
                                <span>{t("loginView.buttonRegister")}</span>
                                <i className="fas fa-chevron-right login-input-login-title-icon"></i>
                              </div>
                            )}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          {/* Texto "¿Ya tienes cuenta?"" */}
                          <div className="login-div-already-have-account">
                            <p>
                              {t("loginView.textDoYouHaveAccount")}{" "}
                              <span
                                className="login-div-already-have-account-link"
                                onClick={() =>
                                  props.onHandleSelectTemplate("login")
                                }
                              >
                                {t("loginView.textHere")}
                              </span>
                            </p>
                          </div>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className="login-div-legal-documents">
                            <p>
                              {t("loginView.textIfYouSuscribeYouMustAcept")}
                              <span
                                className="login-div-legal-documents-link"
                                onClick={() => {
                                  openModalTermsCond(true);
                                }}
                              >
                                {t("loginView.textTermsAndConditions")}
                              </span>
                              <span>{t("loginView.textAsWellThe")}</span>
                              <span
                                className="login-div-legal-documents-link"
                                onClick={() => {
                                  openModalPolicityPrivacy(true);
                                }}
                              >
                                {t("loginView.textPolicityPrivacy")}
                              </span>
                              {t("loginView.wspHelp")}{" "}
                              <a
                                style={{
                                  textDecoration: "underline",
                                  color: "#427fba",
                                }}
                                href="https://wa.me/+528122025327"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("loginView.wspLink")}
                              </a>
                            </p>
                          </div>
                        </Grid>
                      </Grid>
                    ) : null}

                    {/* FORM SEND CHANGE PASSWORD EMAIL */}
                    {props.templateRendering === "forgotPassword" ? (
                      <Grid containerlg={12} md={12} sm={12} xs={12}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          style={loginItemContainerSendEmailMargin}
                        >
                          <div style={loginItemContainerDivSendEmail}>
                            <p style={{ margin: 0 }}>
                              {t("loginView.textPleaseEnterYourEmailAddress")} {t("loginView.textWhichYourHaveRegistered")}
                            </p>
                          </div>
                          {/* Input correo cambio de contraseña */}
                          <div className="login-input-container">
                            <div className="login-input-wrapper">
                              <i className="far fa-envelope login-input-icon" />
                            </div>
                            <input
                              placeholder={t("loginView.placeholderEmail")}
                              type="text"
                              className="login-input"
                              id="resetEmail"
                              onChange={(e) => props.onHandleGeneralChange(e)}
                              onKeyPress={(e) =>
                                props.onHandleResetPasswordKeypress(e)
                              }
                            />
                          </div>
                          {/* Boton Enviar solicitud */}
                          <div
                            className="login-input-button-login-register-forgotPassword"
                            onClick={(e) => props.onHandleResetPassword(e)}
                          >
                            {props.loading === true ? (
                              <p className="preloader"></p>
                            ) : (
                              <div>
                                <span>{t("loginView.buttonSendEmail")}</span>
                                <i className="fas fa-chevron-right login-input-login-title-icon"></i>
                              </div>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>

          <DialogTermsCond
            modalTermsCond={modalTermsCond}
            openModalTermsCond={openModalTermsCond}
          />
          <DialogPoliticyPrivacy
            modalPolicityPrivacy={modalPolicityPrivacy}
            openModalPolicityPrivacy={openModalPolicityPrivacy}
          />
          <DialogSystemGLPure
            isWarnign={props.isWarnign}
            messageWarning={props.messageWarning}
            handleWarningClose={props.handleWarningClose}
            handleWarningSubmit={props.handleWarningSubmit}
            showBtnCancelWarning={false}
            showBtnSubmitWarning={true}
            labelWarningBtnSubmit={t('button.accept')}
            titleDialog={t('login.action.onboardingTitle')}
          />
        </div>
        <FooterLoginPure clientLogo={clientLogo} />
      </div>
    );
  }
};
export { LoginView as default };
